module.exports = __webpack_public_path__ + "img/Loupe.8a7096ca.png";